import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Container,
  Divider,
  Grid,
  IconButton,
  Stack,
  Typography,
  Chip,
} from "@mui/material";
import Wrapper from "../../../components/wrappers/Wrapper";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import usePrimaryColor from "../../../hooks/usePrimaryColor";
import { overflowingTitleSx } from "../../../enums/Styles";
import VaccinesIcon from '@mui/icons-material/Vaccines';
import { trimText } from "../../../utils/Functions";
import { VaccinationCategory } from "../enums/VaccinationCategory";
import { VaccinationDetailsArray } from "../enums/VaccinationDetailsArray";

export default function VaccinationListing({
  vaccination,
  handleRemoveVaccination,
  index,
}) {
  const [isAccordionExpanded, setIsAccordionExpanded] = useState(false);
  const { t } = useTranslation();
  
  const vaccinationDetails = VaccinationDetailsArray(vaccination, t);

  const handleAccordionToggle = () => {
    setIsAccordionExpanded(!isAccordionExpanded);
  };

  function SingleDetail({ title, value }) {
    return (
      <Grid item xs={12} md={6}>
        <Typography variant="caption" color={"GrayText"}>
          {title || "-"}
        </Typography>
        <Typography sx={overflowingTitleSx}>{value || "-"}</Typography>
      </Grid>
    );
  }

  // Get vaccination category label
  const getCategoryLabel = () => {
    if (vaccination.vaccinationCategory === VaccinationCategory.RABIES)
      return t("Rabies");
    if (vaccination.vaccinationCategory === VaccinationCategory.OTHER)
      return t("Other");
    return t("Unknown");
  };

  // Get category color
  const getCategoryColor = () => {
    if (vaccination.vaccinationCategory === VaccinationCategory.RABIES)
      return "error"; // Red for Rabies
    if (vaccination.vaccinationCategory === VaccinationCategory.OTHER)
      return "primary"; // Blue for Other
    return "default";
  };

  return (
    <Accordion
      expanded={isAccordionExpanded}
      onChange={handleAccordionToggle}
      sx={{
        padding: "4px 0",
        boxShadow: "none",
        borderBottom: `1px solid ${usePrimaryColor()}`,
      }}
      data-testid={`appointment.finish-meeting.vaccination.item.${index}`}
    >
      <AccordionSummary
        sx={{
          maxHeight: 10,
          justifyContent: "space-between",
        }}
      >
        <Wrapper noPaper>
          <Stack direction="row" alignItems="center" spacing={1}>
            <VaccinesIcon fontSize="small" color={getCategoryColor()} />
            <Typography
              variant="body2"
              sx={{ fontSize: "0.875rem", ...overflowingTitleSx }}
            >
              {trimText(vaccination.name, 30)}
            </Typography>
            <Chip
              label={getCategoryLabel()}
              color={getCategoryColor()}
              size="small"
            />
          </Stack>
          <Stack direction={"row"} spacing={1} alignItems="center">
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleRemoveVaccination(index);
              }}
              color="error"
              sx={{ padding: 1 }}
              title={t("Delete")}
              data-testid={`appointment.finish-meeting.vaccination.item.${index}.delete-button`}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Stack>
        </Wrapper>
      </AccordionSummary>

      <AccordionDetails>
        <Container sx={{ mb: 2 }}>
          <Divider />
        </Container>
        <Grid container spacing={1}>
          {vaccinationDetails.map((detail, index) => (
            <SingleDetail
              key={index}
              title={detail.title}
              value={detail.value}
            />
          ))}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}